import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import styled, {css} from 'styled-components'

export const StyledGridContainer = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 6}px;
    `
)

export const StyledResponsiveGrid = styled(Grid)(
    ({theme: {mediaQueries}}) => css`
        grid-template-columns: repeat(4, 1fr);

        ${mediaQueries.xl} {
            grid-template-columns: repeat(3, 1fr);
        }

        ${mediaQueries['2xl']} {
            grid-template-columns: repeat(3, 1fr);
        }
    `
)
